<template>
  <div class="agreement-pop" v-if="isShow">
    <div class=agreement-pop-wrap>
      <div class="agreement-pop-text">
        <div class="agreement-pop-title"><img src="@@/assets/img/common/warning.png" class="agreement-pop-title-icon"/>关于华秋个人信息保护与技术必要性收集的说明</div>
        <p class="agreement-pop-desc">欢迎访问华秋电子一站式服务平台！为保障网站安全稳定运行、履行《网络安全法》项下的网络安全保护义务，我们会使用Cookie记录您的基本访问偏好及防攻击识别信息。在您明确授权前，我们通过匿名化技术处理您的访问行为。继续浏览或点击“同意”即代表您认可我们依据最新的<a :href="`${ssoUrl}/help/protocal.html`" target="_blank" class="agreement-link">《华秋平台服务协议》</a>与<a :href="`${ssoUrl}/help/privacy.html`" target="_blank" class="agreement-link">《隐私权协议》</a>处理相关技术性数据，以确保为您提供流畅的询价与采购服务。</p>
      </div>
      <div class="agreement-pop-btn">
        <div class="pop-btn-cancel" @click="handleCancel">不同意</div>
        <div class="pop-btn-confirm" @click="handleConfirm">同意并继续</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AnalyticsPop',
  data() {
    return {
      isShow: false
    }
  },
  computed: {
    ssoUrl() {
      const ht = process.env.VUE_APP_SSOURL
      const protocol = location.protocol
      return `${protocol}//${ht}`
    }
  },
  methods: {
    showPop() {
      this.isShow = true
    },
    handleCancel() {
      this.isShow = false
    },
    handleConfirm() {
      this.isShow = false
      this.$emit('confirm')
    }
  },
} 
</script>
<style lang="scss" scoped>
.agreement-pop {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 140px;
  background: rgba(0, 0, 0, .9);
  z-index: 9999;
}
.agreement-pop-wrap {
  width: 1200px;
  height: 140px;
  margin: 0 auto;
  display: flex;
}
.agreement-pop-title {
  padding-top:24px;
  height: 24px;
  line-height: 24px;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
}
.agreement-pop-title-icon {
  display: inline-block;
  width: 24px;
  margin-right: 10px;
  vertical-align: middle;
}
.agreement-pop-desc {
  margin-top: 12px;
  font-size: 13px;
  color: #cccccc;
  line-height: 20px;
}
.agreement-link {
  color: #0075ff;
}
.agreement-link:hover {
  color: #0075ff;
  text-decoration: underline;
}
.agreement-pop-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  width: 280px;
}
.pop-btn-cancel {
  font-size: 14px;
  line-height: 36px;
  color: #CCCCCC;
  text-align: center;
  width: 100px;
  height: 36px;
  border: 1px solid #666666;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 16px;
}
.pop-btn-confirm{
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 36px;
  width: 120px;
  height: 36px;
  background: #cc0000;
  border-radius: 4px;
  cursor: pointer;
}
</style>